<template>
  <DxDataGrid
    v-bind="commonProps.dataGrid"
    :data-source="merchandise"
    :columns="columns"
    :on-cell-prepared="onCellPrepared"
  />
</template>

<script>
import {
  DxDataGrid,
} from 'devextreme-vue/data-grid';
import { mapActions, mapGetters } from 'vuex';
import { commonProps } from '../trips/tripsColumnData';
import columns, { colMethods } from './cargosTableColumnData';

export default {
  name: 'CargosTable',
  components: {
    DxDataGrid,
  },
  data() {
    return {
      commonProps,
      columns,
    };
  },
  computed: {
    ...mapGetters('Trips', ['merchandise']),
  },
  async beforeMount() {
    await this.getMerchandises();
  },
  methods: {
    onCellPrepared(row) {
      if (row.column.type === 'buttons') this.addButtonFuncs(row.column.buttons);
    },
    ...mapActions('Trips', ['getMerchandises', 'removeMerchandise']),
    ...colMethods,
  },

};
</script>
